// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gf9fa{display:flex;flex-direction:column;width:100%;max-width:600px;margin:0 auto;gap:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `gf9fa`
};
export default ___CSS_LOADER_EXPORT___;
